/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import Pagination from "../Pagination/Pagination";
import "./datatable.scss";
import Modal from "./../Modal/index";
import SearchData, { PageSizeSelect } from "./components/SearchComponent";
import ActionButtons from "./components/ActionButtons";
import ResponsiveTable from "./components/ResponsiveTable";
import { datatableProp } from "./types";
import Delete from "../../assets/Delete";
import Excelsvg from "../../assets/Excelsvg";
import { downloadExcel } from "./excel";
const Datatable = ({
  rows,
  columns,
  title,
  subTitle,
  actionButtons,
  selection,
  tableheadstyle,
  tablerowstyle,
  pagination,
  onSelectionDelete,
  onEditBtnClick,
  onDeleteBtnClick,
  viewButton,
  editButton,
  deleteButton,
  keysToExcludeFromView,
  searchAble,
  handleViewObjects,
  style,
  className,
  excelDownload,
  removefromExcel,
  modalClassName,
  modalStyle,
}: datatableProp) => {
  const [tableRows, setTableRows] = useState(rows);
  const [searchVal, setSearchVal] = useState("");
  const [PageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setTableRows(rows);
  }, [rows]);

  //* ----------- selection function --------
  const [selecteddata, setselecteddata] = useState<row[]>([]);
  const checkIsSelected = (data: row) => {
    const index = selecteddata.indexOf(data);
    if (index !== -1) {
      return true;
    }
    return false;
  };
  const getSelectedIndex = (data: row) => {
    const index = selecteddata.indexOf(data);
    if (index !== -1) {
      return index;
    }
    return false;
  };

  const handleSelectionChange = (row: row) => {
    if (checkIsSelected(row)) {
      const index = getSelectedIndex(row);
      if (typeof index == "number") {
        const updatedData = [
          ...selecteddata.slice(0, index),
          ...selecteddata.slice(index + 1),
        ];
        setselecteddata(updatedData);
      }
    } else {
      setselecteddata([...selecteddata, row]);
    }
  };
  //* ---------- Pagination code ------------

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return tableRows?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, PageSize, tableRows, rows, searchVal]);

  //* ------------- view model functions --------------
  const [modal, setmodal] = useState({ open: false, data: {} });
  return (
    <div
      style={style}
      className={`main ${className}`}
      id="X_RT454566KJKJSDFKJhjd6546546"
    >
      <div className="table-container">
        <div className="mb-2">
          <h2>{title ? title : "Please give an title"}</h2>
          <small className="text-secondary">{subTitle}</small>

          {searchAble == undefined && (
            <div
              style={{
                display: "flex",
                gap: 4,
                justifyContent: `${pagination ? "space-between" : "flex-end"}`,
                alignItems: "center",
              }}
            >
              {pagination && (
                <PageSizeSelect pageSize={PageSize} setPageSize={setPageSize} />
              )}
              <SearchData
                data={rows}
                setData={setTableRows}
                serarchVal={searchVal}
                setSearchVal={setSearchVal}
                setCurrentPage={setCurrentPage}
              />
            </div>
          )}
          {excelDownload && (
            <div
              style={{
                width: "100%",
                padding: "10px 0px",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "space-between",
                gap: 4,
              }}
            >
              <div className="flex">
                <div
                  onClick={() =>
                    downloadExcel(tableRows, title, removefromExcel)
                  }
                  className="successbtn flex excel"
                >
                  <Excelsvg />
                  Download
                </div>
                {selection && onSelectionDelete && (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 7 }}
                  >
                    <div
                      onClick={() => {
                        onSelectionDelete(selecteddata);
                        setselecteddata([]);
                      }}
                      className="dangerbtn flex delbtn"
                    >
                      <Delete />
                      Delete
                    </div>
                    {pagination && selecteddata.length !== rows.length && (
                      <p
                        className="secondarybtn"
                        onClick={() => setselecteddata(tableRows)}
                      >
                        Select all Data
                      </p>
                    )}
                  </div>
                )}
              </div>
              {selection && (
                <>
                  {selecteddata?.length} row is Selected from
                  {tableRows?.length} enteries
                </>
              )}
            </div>
          )}
        </div>
        <ResponsiveTable
          searchString={searchVal}
          rows={rows.length}
          tableRows={tableRows.length}
          tableHead={
            <thead style={{ ...tableheadstyle }}>
              <tr className="header-row">
                {selection && (
                  <th>
                    <input
                      type="checkbox"
                      onChange={() => {
                        if (selecteddata?.length == rows?.length) {
                          setselecteddata([]);
                        } else {
                          setselecteddata(
                            pagination ? currentTableData : tableRows
                          );
                        }
                      }}
                      checked={selecteddata?.length == rows?.length}
                    />
                  </th>
                )}
                <th>#</th>
                {columns.map((col, i) => (
                  <th key={i}>{col.headerName}</th>
                ))}
                {actionButtons && <th className="text-center">Actions</th>}
              </tr>
            </thead>
          }
        >
          {rows &&
            (pagination ? currentTableData : tableRows)?.map(
              (data, i: number) => {
                const indexnumber = tableRows?.indexOf(data as never);
                const isSelect = checkIsSelected(data);
                return (
                  <tr
                    key={i}
                    style={{ ...tablerowstyle, ...{ cursor: "pointer" } }}
                    onClick={() => {
                      if (selection) {
                        handleSelectionChange(data);
                      }
                    }}
                    className={`${isSelect && "activeRow"}`}
                  >
                    {selection && (
                      <td>
                        <input
                          type="checkbox"
                          checked={isSelect}
                          onChange={() => handleSelectionChange(data)}
                        />
                      </td>
                    )}
                    <td>{typeof data === "object" && indexnumber + 1}</td>
                    {columns.map((col, j) => {
                      const val = data[col.field];
                      return (
                        <React.Fragment key={j}>
                          {!col.renderCell && (
                            <td style={col.style}>
                              {JSON.stringify(val)?.replace(/"/g, "")}
                            </td>
                          )}
                          {col.renderCell && (
                            <td style={col.style}>{col?.renderCell(data)}</td>
                          )}
                        </React.Fragment>
                      );
                    })}
                    {actionButtons && (
                      <td>
                        <ActionButtons
                          config={{
                            onEditBtnClick,
                            onDeleteBtnClick,
                            viewButton,
                            editButton,
                            deleteButton,
                          }}
                          data={data}
                          setModal={() => setmodal({ open: true, data })}
                        />
                      </td>
                    )}
                  </tr>
                );
              }
            )}
        </ResponsiveTable>

        <footer>
          {pagination && searchVal == "" && (
            <p className="col-12 col-md-6">
              Showing{" "}
              {pagination ? PageSize * currentPage - PageSize + 1 : rows.length}{" "}
              to {pagination ? PageSize * currentPage : rows.length} of{" "}
              {rows.length} entries
            </p>
          )}

          {!pagination && searchVal == "" && (
            <p className="col-12 col-md-6">
              Showing {rows.length} of {rows.length} entries
            </p>
          )}
          {searchVal !== "" && rows.length !== 0 && (
            <p className="col-12 col-md-6">
              Showing {tableRows.length} of {rows.length} entries
            </p>
          )}

          {pagination && (
            <div className="col-12 col-md-6 justify-center">
              <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={rows.length}
                pageSize={PageSize}
                onPageChange={(page: number) => setCurrentPage(page)}
              />
            </div>
          )}
        </footer>
      </div>
      <Modal
        modalClassName={modalClassName}
        modalStyle={modalStyle}
        show={modal.open}
        title={title}
        onHide={() => setmodal({ open: false, data: {} })}
        data={modal.data}
        KeysToHide={keysToExcludeFromView}
        handleViewObjects={handleViewObjects}
      />
    </div>
  );
};
export default Datatable;
